import { useState } from 'react';

interface UseSetupAccordionsReturn {
  isProductSectionOpen: boolean;
  setIsProductSectionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isCastingSectionOpen: boolean;
  setIsCastingSectionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isScenarioSettingsOpen: boolean;
  setIsScenarioSettingsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isScenarioAdvancedOpen: boolean;
  setIsScenarioAdvancedOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFirstFrameSettingsOpen: boolean;
  setIsFirstFrameSettingsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isVideoSettingsOpen: boolean;
  setIsVideoSettingsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isPromptSectionOpen: boolean;
  setIsPromptSectionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isPromptVideoSettingsOpen: boolean;
  setIsPromptVideoSettingsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openAllAccordions: () => void;
  closeAllAccordions: () => void;
  /** openAll/closeAll 対象の全セクションが開いているか (1ボタントグルの表示判定) */
  areAllAccordionsOpen: boolean;
}

export type { UseSetupAccordionsReturn };

export function useSetupAccordions(): UseSetupAccordionsReturn {
  const [isProductSectionOpen, setIsProductSectionOpen] = useState(true);
  const [isCastingSectionOpen, setIsCastingSectionOpen] = useState(false);
  const [isScenarioSettingsOpen, setIsScenarioSettingsOpen] = useState(false);
  const [isScenarioAdvancedOpen, setIsScenarioAdvancedOpen] = useState(false);
  const [isFirstFrameSettingsOpen, setIsFirstFrameSettingsOpen] = useState(false);
  const [isVideoSettingsOpen, setIsVideoSettingsOpen] = useState(false);
  // プロンプトモード用 (openAll/closeAll は対象外: ボタンが Setup phase のみのため)
  const [isPromptSectionOpen, setIsPromptSectionOpen] = useState(true);
  const [isPromptVideoSettingsOpen, setIsPromptVideoSettingsOpen] = useState(false);

  const openAllAccordions = () => {
    setIsProductSectionOpen(true);
    setIsCastingSectionOpen(true);
    setIsScenarioSettingsOpen(true);
    setIsFirstFrameSettingsOpen(true);
    setIsVideoSettingsOpen(true);
  };

  const closeAllAccordions = () => {
    setIsProductSectionOpen(false);
    setIsCastingSectionOpen(false);
    setIsScenarioSettingsOpen(false);
    setIsFirstFrameSettingsOpen(false);
    setIsVideoSettingsOpen(false);
  };

  const areAllAccordionsOpen =
    isProductSectionOpen && isCastingSectionOpen && isScenarioSettingsOpen && isFirstFrameSettingsOpen && isVideoSettingsOpen;

  return {
    isProductSectionOpen,
    setIsProductSectionOpen,
    isCastingSectionOpen,
    setIsCastingSectionOpen,
    isScenarioSettingsOpen,
    setIsScenarioSettingsOpen,
    isScenarioAdvancedOpen,
    setIsScenarioAdvancedOpen,
    isFirstFrameSettingsOpen,
    setIsFirstFrameSettingsOpen,
    isVideoSettingsOpen,
    setIsVideoSettingsOpen,
    isPromptSectionOpen,
    setIsPromptSectionOpen,
    isPromptVideoSettingsOpen,
    setIsPromptVideoSettingsOpen,
    openAllAccordions,
    closeAllAccordions,
    areAllAccordionsOpen,
  };
}
